// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5u-1";
export var standaloneTable = "_5u-0";